import React, { useState, useEffect } from "react";
import {
  FiSearch,
  FiUser,
  FiShoppingCart,
  FiMenu,
  FiX,
} from "react-icons/fi";
import { BiSupport } from "react-icons/bi";
import { IoIosArrowDown } from "react-icons/io";
import { Link } from "react-router-dom";
import "../Header/Header.css";

const Header = ({ cartCount, toggleCart }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [mobileDropdown, setMobileDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const categories = [
    {
      name: "Gardening",
      options: ["Gardening Tools", "Indoor Gardening", "Outdoor Gardening"],
    },
    {
      name: "Plants",
      options: ["Flowering Plants", "Indoor Plants", "Outdoor Plants"],
    },
    {
      name: "Seeds",
      options: ["Vegetable Seeds", "Fruit Seeds", "Herb Seeds"],
    },
    {
      name: "Bulbs",
      options: ["Flower Bulbs", "Seasonal Bulbs", "Exotic Bulbs"],
    },
    {
      name: "Planters",
      options: ["Plastic Planters", "Ceramic Planters", "Hanging Planters"],
    },
    {
      name: "Soil & Fertilizer",
      options: ["Organic Fertilizers", "Potting Soil", "Soil Conditioners"],
    },
    {
      name: "Gifts",
      options: ["Gift Plants", "Plant Combos", "Customizable Gifts"],
    },
    {
      name: "Pebbles",
      options: ["Decorative Pebbles", "Garden Pebbles", "Colored Pebbles"],
    },
    {
      name: "Accessories",
      options: ["Garden Gloves", "Watering Cans", "Plant Stands"],
    },
    {
      name: "Corporate",
      options: ["Corporate Gifts", "Office Plants", "Custom Solutions"],
    },
  ];

  const toggleDropdown = (category) => {
    setActiveDropdown(activeDropdown === category ? null : category);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleMobileDropdown = (category) => {
    setMobileDropdown(
      mobileDropdown === category ? null : category
    );
  };

  return (
    <>
      <header className={`header ${isScrolled ? "scrolled" : ""}`}>
        <div className="header-top">
          <div className="logo-container">
            <button className="hamburger-menu" onClick={toggleMenu}>
              <FiMenu />
            </button>

            <Link className="hl" to="/">
              <div className="logo-h">Nursery</div>
            </Link>
          </div>

          <div className="search-box">
            <select className="category-dropdown">
              <option>All categories</option>

              {categories.map((category) => (
                <option key={category.name}>
                  {category.name}
                </option>
              ))}
            </select>

            <input
              type="text"
              placeholder="What are you looking for?"
            />

            <button className="search-button">
              <FiSearch />
            </button>
          </div>

          <div className="extras">
            <div className="support">
              <BiSupport className="support-icon" />

              <div>
                <span>Expert Support</span>
                <small>Available 24/7</small>
              </div>
            </div>

            <button className="login-button">
              <FiUser /> Login
            </button>

            <button className="cart-button" onClick={toggleCart}>
              <FiShoppingCart />
              Cart

              {cartCount > 0 && (
                <span className="cart-count">
                  {cartCount}
                </span>
              )}
            </button>
          </div>
        </div>

        {/* Desktop Nav */}
        <nav className="nav-bar">
          <ul>
            {categories.map((category) => (
              <li
                className="dropdown"
                key={category.name}
                onClick={() => toggleDropdown(category.name)}
              >
                {category.name}

                <IoIosArrowDown
                  className={`arrow-icon ${
                    activeDropdown === category.name
                      ? "open"
                      : ""
                  }`}
                />

                {activeDropdown === category.name && (
                  <ul className="dropdown-menu">
                    {category.options.map((option, index) => (
                      <li key={index}>{option}</li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </header>

      {/* Overlay */}
      <div
        className={`slider-overlay ${
          isMenuOpen ? "show-overlay" : ""
        }`}
        onClick={toggleMenu}
      ></div>

      {/* Mobile Slider Menu */}
      <div className={`slider-menu ${isMenuOpen ? "open" : ""}`}>
        <button className="close-menu" onClick={toggleMenu}>
          <FiX />
        </button>

        <ul>
          <li>
            <Link to="/" onClick={toggleMenu}>
              Home
            </Link>
          </li>

          <li>
            <Link to="/aboutus" onClick={toggleMenu}>
              About
            </Link>
          </li>

          <li>
            <Link to="/servicesmain" onClick={toggleMenu}>
              Services
            </Link>
          </li>

          <li>
            <Link to="/contact" onClick={toggleMenu}>
              Contact
            </Link>
          </li>
        </ul>

        {/* Categories inside slider */}
        <div className="mobile-categories">
          <h3>Categories</h3>

          {categories.map((category) => (
            <div
              className="mobile-category"
              key={category.name}
            >
              <div
                className="mobile-category-title"
                onClick={() =>
                  toggleMobileDropdown(category.name)
                }
              >
                <span>{category.name}</span>

                <IoIosArrowDown
                  className={`arrow-icon ${
                    mobileDropdown === category.name
                      ? "open"
                      : ""
                  }`}
                />
              </div>

              {mobileDropdown === category.name && (
                <ul className="mobile-dropdown">
                  {category.options.map((option, index) => (
                    <li key={index}>{option}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Header;